function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Trigger from '@cloud-sn/v-trigger';
import { isArray, warning, isVueComponent, extractVNodeData, cloneVNode } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import placements from './placements';

function isMenuCmp(vnode) {
  if (!isVueComponent(vnode)) return false;
  var Ctor = vnode.componentOptions.Ctor; // ux-menu, v-menu

  return Ctor.extendOptions.name.indexOf('Menu') > -1;
}

export default {
  name: buildComponentName('Dropdown'),
  inheritAttrs: false,
  model: {
    prop: 'visible'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-dropdown'
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: [Array, String],
      default: 'hover'
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    placement: {
      type: String,
      default: 'bottomLeft'
    },
    mouseEnterDelay: {
      type: Number,
      // ms
      default: 150
    },
    mouseLeaveDelay: {
      type: Number,
      // ms
      default: 100
    },
    transitionName: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    },
    overlayClass: {
      type: [String, Array, Object],
      default: ''
    },
    overlayStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    align: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    matchTriggerWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerVisible: false,
      triggerWidth: null
    };
  },
  computed: {
    actions: function actions() {
      var disabled = this.disabled,
          trigger = this.trigger;

      if (disabled) {
        return [];
      }

      return isArray(trigger) ? trigger : [trigger];
    },
    dropdownTransition: function dropdownTransition() {
      var transitionName = this.transitionName,
          placement = this.placement;
      var transition = transitionName;

      if (!transition) {
        transition = placement.indexOf('top') > -1 ? 'slide-down' : 'slide-up';
      }

      return transition;
    },
    popupStyle: function popupStyle() {
      var matchTriggerWidth = this.matchTriggerWidth,
          triggerWidth = this.triggerWidth;
      return triggerWidth ? _defineProperty({}, matchTriggerWidth ? 'width' : 'min-width', "".concat(triggerWidth, "px")) : null;
    }
  },
  watch: {
    visible: function visible(nVal) {
      this.setInnerVisible(nVal);
    }
  },
  created: function created() {
    this.setInnerVisible(this.visible);
  },
  methods: {
    setOverlayWidth: function setOverlayWidth() {
      var $el = this.$el;
      this.triggerWidth = $el.offsetWidth;
    },
    setInnerVisible: function setInnerVisible(visible) {
      this.innerVisible = visible;
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible);
      this.$emit('input', visible);
      this.$emit('visible-change', visible);

      if (visible) {
        this.setOverlayWidth();
      }
    },
    onClick: function onClick(e) {
      var setInnerVisible = this.setInnerVisible,
          closeOnSelect = this.closeOnSelect;

      if (closeOnSelect) {
        setInnerVisible(false);
      }

      this.$emit('overlay-click', e);
    },
    validateTriggerAndOverlay: function validateTriggerAndOverlay() {
      var _this$$slots = this.$slots,
          overlay = _this$$slots.overlay,
          trigger = _this$$slots.trigger;

      if (process.env.NODE_ENV !== 'production') {
        if (!trigger) {
          warning(false, 'You need an `trigger` slot element!');
          return false;
        }

        if (!overlay) {
          warning(false, 'You need an `overlay` slot element!');
          return false;
        }
      }

      return true;
    },
    getTriggerAndOverlayNode: function getTriggerAndOverlayNode() {
      var _this$$slots2 = this.$slots,
          _this$$slots2$trigger = _slicedToArray(_this$$slots2.trigger, 1),
          triggerNode = _this$$slots2$trigger[0],
          _this$$slots2$overlay = _slicedToArray(_this$$slots2.overlay, 1),
          overlayNode = _this$$slots2$overlay[0],
          prefixCls = this.prefixCls,
          disabled = this.disabled,
          onClick = this.onClick;

      var triggerData = extractVNodeData(triggerNode, isVueComponent(triggerNode));
      var nTriggerNode = cloneVNode(triggerNode, {
        class: [triggerData.class, "".concat(prefixCls, "-trigger")],
        props: _objectSpread({}, triggerData.props),
        attrs: _objectSpread({}, triggerData.attrs, {
          disabled: disabled
        })
      }, false);
      var overlayData = extractVNodeData(overlayNode, isVueComponent(overlayNode));
      var nOverlayProps = {}; // menu组件时

      if (isMenuCmp(overlayNode)) {
        nOverlayProps.mode = 'vertical';
        nOverlayProps.isDropdownMenu = true;
        nOverlayProps.prefixCls = "".concat(prefixCls, "-menu");
      }

      var _ref2 = overlayData.on || {},
          originClick = _ref2.click;

      var overlayClick = originClick ? [originClick, onClick] : onClick;
      var nOverlayNode = cloneVNode(overlayNode, {
        props: _objectSpread({}, overlayData.props, {}, nOverlayProps),
        on: _objectSpread({}, overlayData.on, {
          click: overlayClick
        })
      }, false);
      return {
        trigger: nTriggerNode,
        overlay: nOverlayNode
      };
    },
    renderTrigger: function renderTrigger() {
      var h = this.$createElement;
      var $attrs = this.$attrs,
          prefixCls = this.prefixCls,
          popupStyle = this.popupStyle,
          overlayClass = this.overlayClass,
          overlayStyle = this.overlayStyle,
          onPopupVisibleChange = this.onPopupVisibleChange,
          placement = this.placement,
          actions = this.actions,
          align = this.align,
          dropdownTransition = this.dropdownTransition,
          animation = this.animation,
          innerVisible = this.innerVisible,
          getPopupContainer = this.getPopupContainer,
          getTriggerAndOverlayNode = this.getTriggerAndOverlayNode;

      var _getTriggerAndOverlay = getTriggerAndOverlayNode(),
          trigger = _getTriggerAndOverlay.trigger,
          overlay = _getTriggerAndOverlay.overlay;

      var props = {
        prefixCls: prefixCls,
        popupClass: [overlayClass],
        popupStyle: _objectSpread({}, popupStyle, {}, overlayStyle),
        builtinPlacements: placements,
        popupPlacement: placement,
        actions: actions,
        popupAlign: align,
        popupTransitionName: dropdownTransition,
        popupAnimation: animation,
        visible: innerVisible,
        getPopupContainer: getPopupContainer
      };
      var on = {
        'popup-visible-change': onPopupVisibleChange
      };
      return h(Trigger, {
        "attrs": _objectSpread({}, $attrs),
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, on)
      }, [h("template", {
        "slot": "trigger"
      }, [trigger]), h("template", {
        "slot": "popup"
      }, [overlay])]);
    }
  },
  render: function render() {
    var validateTriggerAndOverlay = this.validateTriggerAndOverlay,
        renderTrigger = this.renderTrigger;

    if (!validateTriggerAndOverlay()) {
      return null;
    }

    return renderTrigger();
  }
};